import React, { useEffect } from 'react'
import GalleryMegaEdit from '../../../components/GalleryMegaEdit'
import { useSearchParams, useLocation } from 'react-router-dom'

const AnnouncePicturesForm: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const location = useLocation()

  useEffect(() => {
    let step = '7'
    if (
      location.pathname.includes('announce-event') ||
      location.pathname.includes('announce-work') ||
      location.pathname.includes('announce-establishment')
    ) {
      step = '6'
    } else if (location.pathname.includes('announce-libertin')) {
      step = '5'
    }
    setSearchParams({ step }, { replace: true })
  }, [location.pathname, setSearchParams])

  return (
    <div className='announce-pictures-form'>
      <GalleryMegaEdit />
    </div>
  )
}

export default AnnouncePicturesForm
